import React from "react";
import { getContentUrl, ContentURL } from "../../Utils/ContentURL";
import { useAppState } from "../../../Redux/ReduxHooks";
import { CreditCardPlaceholder, PayPalGuestTempPlaceholder } from "../../Payment/PaymentEntities";
import { BookingStatus } from "../../../Services/BookingEntities";

/**
 * Displays the Fixed Price and payment details if the booking is successfully converted to a fixed price booking.
 */
export const ConfirmedFixedPriceSection: React.FC = () => {

    const bookingDetails = useAppState(state => state.PhoneToCnp.Booking);
    const isPaymentSucceeded = useAppState(state => state.PhoneToCnp.IsPaymentConfirmed);
    const paymentOption = useAppState(state => state.PhoneToCnp.PaymentOption);
    const appState = useAppState(state => state);

    let paymentDetails = "";

    if (bookingDetails?.Payment) {
        paymentDetails = `${bookingDetails?.Payment?.CardType} ${bookingDetails?.Payment?.CardNumber}`;
    }
    // booking has been just converted to CNP. In that case booking.payment will be null. we get payment details from local data.
    else if (isPaymentSucceeded) {
        if (paymentOption?.Type == "ApplePay") paymentDetails = "Apple Pay";

        // book with Google Pay
        if (paymentOption?.Type == "GooglePay") paymentDetails = "Google Pay";

        // book with a credit/debit card as a guest
        if (paymentOption === CreditCardPlaceholder) paymentDetails = `${appState.payment.GuestCreditCard?.CardType} ${appState.payment.GuestCreditCard?.CardNumber}`;

        // book with PayPal
        if (paymentOption === PayPalGuestTempPlaceholder) paymentDetails = "PayPal";
    }

    let paymentHoldText = "This is only a hold. You'll be charged after your trip.";

    if (bookingDetails?.TrackingInfo.BookingStatusID === BookingStatus.Completed) paymentHoldText = "Your payment is complete."

    return (
        <div className="confirmed-fixed-price-section">
            <div className="confirmed-fixed-price-details">
                <div>
                    <div className="confirmed-fixed-price-title">Fixed Price</div>
                    <div className="confirmed-payment-details">{paymentDetails}</div>
                </div>
                <div className="fare-amount">
                    <img className="lock-icon" src={getContentUrl(ContentURL.images.PhoneToCnp.LockIcon)}></img>
                    <span>{`$${bookingDetails?.Fare.FixedPriceDollars.toFixed(2)}`}</span>
                </div>
            </div>
            <div className="payment-hold-description">{paymentHoldText}</div>
        </div>
    )
}